<template>
<div class="cnt-slider">
    <div class="lst-slider">
        <slick class="slider-row slick" ref="cashSlick" :options="slickOptions" @afterChange="onChangeCashDetails">
            <li v-for="item in cashDetails.cash_currency.slice(0,6)" :key="item.id">
                <div class="box-news">
                    <div class="box-heading">
                        <div class="name-item">{{cashDetails.name}}</div>
                        <div
                            class="date-item"
                        >{{ dateUtils.formatDateYYYYMMDD(cashDetails.days_from) }}({{ dateUtils.getDay(cashDetails.days_from) }})~{{ dateUtils.formatDateYYYYMMDD(cashDetails.days_to) }}({{ dateUtils.getDay(cashDetails.days_to) }})</div>
                        <div class="unit-date">{{ utils.getCurrencyName(item.currency_id) }}</div>
                    </div>

                    <div class="list-cnt-item">
                        <div class="cnt-item">
                            <div class="cnt-item-ttl">{{ useBizPrePaidCard ? $t('cash.withdrawal_and_biz_pre_paid_card') : $t('cash.withdrawal')}}</div>
                            <div
                                class="cnt-item-num"
                            >{{utils.formatPrice(item.total, item.currency_id)}}{{ utils.getCurrencyName(item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="cnt-item-ttl">{{$t('cash.expenditure')}}</div>
                            <div
                                class="cnt-item-num"
                            >{{ utils.formatPrice(item.total_expenditure, item.currency_id) }}{{ utils.getCurrencyName(item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="cnt-item-ttl">{{$t('cash.income')}}</div>
                            <div
                                class="cnt-item-num"
                            >{{ utils.formatPrice(item.total_income, item.currency_id) }}{{ utils.getCurrencyName(item.currency_id) }}</div>
                        </div>
                        <div class="cnt-item">
                            <div class="cnt-item-ttl">{{$t('cash.remaining')}}</div>
                            <div
                                class="cnt-item-num"
                            >{{utils.formatPrice(item.total_balance, item.currency_id)}}{{ utils.getCurrencyName(item.currency_id) }}</div>
                        </div>
                    </div>
                </div>
            </li>
        </slick>
    </div>
</div>
</template>
<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

export default {
    name: "SpCashSummary",
    props: {
        cashDetails: {},
        onChangeCashDetails: {type: Function },
        slickOptions: {},
        useBizPrePaidCard:false
    },
    components: {
        Slick,
    },
    data() {
        return {
            utils: Utils,
            dateUtils: DateUtils,
        };
    },
    methods: {
    }
};
</script>




// WEBPACK FOOTER //
// src/views/components/common/Summary/CashSummary.vue